import { initMetric } from './lib/initMetric.js';
const afterLoad = (callback) => {
    if (document.readyState === 'complete') {
        // Queue a task so the callback runs after `loadEventEnd`.
        setTimeout(callback, 0);
    }
    else {
        // Queue a task so the callback runs after `loadEventEnd`.
        addEventListener('load', () => setTimeout(callback, 0));
    }
};
export const getNavigationTiming = (onReport) => {
    const metric = initMetric('navigation_timing');
    afterLoad(() => {
        try {
            // Use the NavigationTiming L2 entry if available.
            const navigationEntry = performance.getEntriesByType('navigation')[0] || undefined;
            metric.params = navigationEntry.toJSON();
            // console.log("navigationEntry.toJSON()", navigationEntry.toJSON());
            onReport(metric);
        }
        catch (error) {
            // Do nothing.
        }
    });
};
